var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "expert-card" }, [
    _c("div", { staticClass: "expert-card__photo" }, [
      _vm.photo
        ? _c("img", { attrs: { src: _vm.imgUrl, alt: "avatar" } })
        : _c("img", {
            attrs: {
              src: require("../../assets/images/avatar.jpg"),
              alt: "avatar",
            },
          }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "expert-card__info" }, [
      _c("div", { staticClass: "expert-card__name" }, [
        _vm._v("\n      " + _vm._s(_vm.name) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "expert-card__email",
          attrs: { href: `mailto:${_vm.email}` },
        },
        [
          _c("Icon", { attrs: { icon: "email" } }),
          _vm._v("\n      " + _vm._s(_vm.email) + "\n    "),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }